var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "delivery-order-card p-1 rounded",
      class:
        ((_obj = {
          "pending-answer": _vm.data.hasChatPendingAnswer,
          "about-to-expire": _vm.isAboutToExpire,
          delayed: _vm.isDelayed,
        }),
        (_obj[_vm.cardStatus.cardClass] = true),
        _obj),
      attrs: { id: "div_" + _vm.data.id },
    },
    [
      _c(
        "div",
        [
          _vm.data.isPaid
            ? _c("p", { staticStyle: { "margin-bottom": "1px" } }, [
                _c(
                  "sup",
                  { staticClass: "pr-1" },
                  [
                    _c(
                      "b-badge",
                      {
                        staticStyle: { "font-size": "13px", width: "100%" },
                        attrs: { variant: "success" },
                      },
                      [
                        _vm._v(" " + _vm._s(_vm.$t("Pago")) + " "),
                        _vm.data.isPaid &&
                        _vm.data.onlinePayment &&
                        _vm.data.onlinePayment.paymentModel === "PayOnline"
                          ? _c("b", [
                              _vm._v(
                                "(" +
                                  _vm._s(_vm.$t("enviar cupom fiscal")) +
                                  ")"
                              ),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm.data.deliveryOrder && !_vm.visibleDispatches.length
            ? _c("p", [
                _c(
                  "sup",
                  { staticClass: "pr-1" },
                  [
                    _c(
                      "b-badge",
                      {
                        staticStyle: {
                          "font-size": "13px",
                          width: "100%",
                          "text-wrap-mode": "wrap",
                        },
                        attrs: { variant: "info" },
                      },
                      [
                        _vm.deliverySupplierName
                          ? [_vm._v(_vm._s(_vm.deliverySupplierName) + " / ")]
                          : _vm._e(),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "PAY_BOX_SALE.DELIVERY_STATUS." +
                                  _vm.data.deliverySupplierStatus
                              )
                            ) +
                            " "
                        ),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm.dispatchesCancelled
            ? _c(
                "div",
                { staticClass: "delivery-dispatches-canceled mb-1" },
                [
                  _c("b-icon", {
                    staticClass: "mr-50",
                    attrs: { icon: "x-circle" },
                  }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("Despachos automáticos cancelados")) +
                      " "
                  ),
                ],
                1
              )
            : _vm.visibleDispatches.length
            ? _c(
                "div",
                { staticClass: "delivery-dispatches mb-1" },
                _vm._l(_vm.visibleDispatches, function (dispatch) {
                  return _c(
                    "div",
                    {
                      key: _vm.dispatchKey(dispatch),
                      staticClass:
                        "delivery-dispatch delivery-dispatch--clickable",
                      class: {
                        "delivery-dispatch--active":
                          _vm.isDispatchActive(dispatch),
                      },
                      attrs: { role: "button", title: _vm.$t("Ver Entrega") },
                      on: {
                        click: function ($event) {
                          return _vm.showDispatchDetails(dispatch)
                        },
                      },
                    },
                    [
                      _vm.dispatchIcon(dispatch)
                        ? _c("img", {
                            staticClass: "delivery-dispatch__icon",
                            attrs: {
                              src: _vm.dispatchIcon(dispatch),
                              alt: _vm.dispatchSupplierName(dispatch),
                            },
                          })
                        : _c("b-icon", {
                            staticClass: "delivery-dispatch__icon",
                            attrs: { icon: "truck" },
                          }),
                      _c("span", { staticClass: "delivery-dispatch__name" }, [
                        _vm._v(_vm._s(_vm.dispatchSupplierName(dispatch))),
                      ]),
                      _c(
                        "b-badge",
                        {
                          attrs: {
                            variant: _vm.dispatchStatusVariant(dispatch),
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.dispatchStatusLabel(dispatch)) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e(),
          _vm.showAssignmentCountdown
            ? _c(
                "div",
                { staticClass: "motoboy-countdown mb-1" },
                [
                  _c("b-icon", {
                    staticClass: "mr-50",
                    attrs: { icon: "clock-history" },
                  }),
                  _vm._v(" " + _vm._s(_vm.assignmentCountdownLabel) + " "),
                ],
                1
              )
            : _vm._e(),
          _vm.manualHandlingMessage
            ? _c(
                "b-alert",
                {
                  staticClass: "py-50 px-1 mb-1",
                  attrs: { show: "", variant: "danger" },
                },
                [
                  _c("strong", [
                    _vm._v(
                      _vm._s(_vm.$t("Tratamento manual necessário")) + ":"
                    ),
                  ]),
                  _vm._v(" " + _vm._s(_vm.manualHandlingMessage) + " "),
                ]
              )
            : _vm._e(),
          _vm.isDelayed || _vm.isAboutToExpire
            ? _c("p", [
                _vm.isDelayed
                  ? _c(
                      "sup",
                      { staticClass: "pr-1" },
                      [
                        _c(
                          "b-badge",
                          {
                            staticStyle: { "font-size": "13px" },
                            attrs: { variant: "danger" },
                          },
                          [
                            _vm._v(
                              " Atrasado em " + _vm._s(_vm.delayLabel) + " "
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm.isAboutToExpire
                  ? _c(
                      "sup",
                      { staticClass: "pr-1" },
                      [
                        _c(
                          "b-badge",
                          {
                            staticStyle: { "font-size": "13px" },
                            attrs: { variant: "info" },
                          },
                          [
                            _vm._v(
                              " Vence em " + _vm._s(_vm.expiresInLabel) + " "
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _c(
            "div",
            {
              staticClass:
                "d-inline-block position-relative mr-1 cursor-pointer",
              on: {
                click: function ($event) {
                  return _vm.showChat(_vm.data)
                },
              },
            },
            [
              _c("b-icon", { attrs: { icon: "chat", "font-scale": "1.5" } }),
              _vm.data.totalUnreadMessages || _vm.data.totalMessages
                ? _c(
                    "b-badge",
                    {
                      staticClass:
                        "position-absolute top-0 start-100 translate-middle",
                      attrs: {
                        variant: _vm.data.totalUnreadMessages
                          ? "danger"
                          : "success",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.data.totalUnreadMessages ||
                              _vm.data.totalMessages
                          ) +
                          " "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("span", { staticClass: "title" }, [
            _vm._v(
              _vm._s(_vm.data.customer.name || "") +
                " (" +
                _vm._s(_vm.saleOriginLabel(_vm.data.origin)) +
                ")"
            ),
          ]),
          _c("p"),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { md: "6" } }, [
                _c("span", { staticClass: "title" }, [
                  _vm._v("Agendado para:"),
                ]),
                _vm._v(" "),
                _c("br"),
                _c("span", { staticClass: "data" }, [
                  _vm._v(_vm._s(_vm.formattedDeliveryDate)),
                ]),
              ]),
              _c("b-col", { attrs: { md: "6" } }, [
                _c("span", { staticClass: "title" }, [_vm._v("Criado em:")]),
                _vm._v(" "),
                _c("br"),
                _c("span", { staticClass: "data" }, [
                  _vm._v(_vm._s(_vm._f("datetime")(_vm.data.issueDate))),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "b-row",
            { staticClass: "mt-1" },
            [
              _c("b-col", { attrs: { md: "6" } }, [
                _c("span", { staticClass: "title" }, [_vm._v("N.º Venda:")]),
                _vm._v(" "),
                _c("br"),
                _c("span", { staticClass: "data" }, [
                  _vm._v(_vm._s(_vm.data.id)),
                ]),
              ]),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c("span", { staticClass: "title" }, [_vm._v("Total:")]),
                  _vm._v(" "),
                  _c("br"),
                  _c("span", { staticClass: "data" }, [
                    _vm._v(_vm._s(_vm._f("currency")(_vm.data.netValue))),
                  ]),
                  _c("e-button", {
                    staticClass: "ml-50",
                    staticStyle: { padding: "10px" },
                    attrs: {
                      id: "btn_view_items_" + _vm.data.id,
                      text: _vm.$t("Itens"),
                      variant: "secondary",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-row",
            { staticClass: "mt-1" },
            [
              _c("b-col", { attrs: { md: "12" } }, [
                _c("span", { staticClass: "title" }, [_vm._v("Endereço:")]),
                _vm._v(" "),
                _c("br"),
                _c("span", { staticClass: "data" }, [
                  _vm._v(_vm._s(_vm.formatAddress(_vm.data.deliveryAddress))),
                ]),
              ]),
            ],
            1
          ),
          _vm.showMotoboyAssignment
            ? _c(
                "div",
                { staticClass: "motoboy-assignment mt-1" },
                [
                  _vm.assignedMotoboyName
                    ? _c("div", { staticClass: "mb-50" }, [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.$t("Motoboy responsável")) + ":"),
                        ]),
                        _vm._v(" " + _vm._s(_vm.assignedMotoboyName) + " "),
                      ])
                    : _vm._e(),
                  _vm.canManageMotoboyAssignment
                    ? _c("b-form-select", {
                        attrs: {
                          size: "sm",
                          options: _vm.motoboyOptions,
                          disabled:
                            _vm.assignmentPending ||
                            _vm.supplierDeliveryInProgress,
                        },
                        on: { change: _vm.onMotoboySelected },
                        model: {
                          value: _vm.selectedMotoboyId,
                          callback: function ($$v) {
                            _vm.selectedMotoboyId = $$v
                          },
                          expression: "selectedMotoboyId",
                        },
                      })
                    : _vm._e(),
                  _vm.canManageMotoboyAssignment &&
                  _vm.supplierDeliveryInProgress
                    ? _c("small", { staticClass: "text-muted d-block mt-25" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "Cancele a entrega do fornecedor para designar um Motoboy."
                              )
                            ) +
                            " "
                        ),
                      ])
                    : _vm._e(),
                  _vm.canManageMotoboyAssignment && _vm.assignedMotoboyId
                    ? _c(
                        "div",
                        { staticClass: "d-flex flex-wrap mt-50" },
                        [
                          _c("e-button", {
                            staticClass: "mb-50",
                            attrs: {
                              size: "sm",
                              variant: "outline-danger",
                              icon: "x-circle",
                              busy: _vm.assignmentPending,
                              text: _vm.$t("Remover Motoboy"),
                            },
                            on: { click: _vm.removeMotoboyAssignment },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "mt-1 mb-0 d-flex justify-content-between" },
            [
              _vm.cardStatus.btnStatus.show
                ? _c("e-button", {
                    staticClass: "w-50 mx-25",
                    attrs: {
                      size: "sm",
                      icon: _vm.cardStatus.btnStatus.icon,
                      text: _vm.cardStatus.btnStatus.text,
                      busy: _vm.motoboyStartPending,
                    },
                    on: { click: _vm.onChangeDeliveryStatus },
                  })
                : _vm._e(),
              _vm.canRequestDelivery &&
              !_vm.data.deliveryOrder &&
              !_vm.hasPendingDispatch
                ? _c("e-button", {
                    staticClass: "w-50 mx-1",
                    attrs: {
                      size: "sm",
                      icon: "truck",
                      busy: _vm.fetching,
                      text: _vm.$t("Solicitar Entrega"),
                    },
                    on: { click: _vm.onAskDeliveryService },
                  })
                : _vm._e(),
              _vm.data.deliveryOrder
                ? _c("e-button", {
                    staticClass: "w-50 mx-1",
                    attrs: {
                      size: "sm",
                      icon: "truck",
                      busy: _vm.fetching,
                      text: _vm.$t("Ver Entrega"),
                    },
                    on: { click: _vm.onShowDeliveryOrder },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("b-tooltip", {
        ref: "tooltip_" + _vm.data.id,
        staticClass: "transparent-tooltip",
        attrs: { target: "btn_view_items_" + _vm.data.id },
        on: { shown: _vm.loadTableData },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function () {
              return [
                _c("delivery-products", {
                  ref: "deliveryProducts",
                  attrs: { "order-id": _vm.data.id },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("delivery-estimate-side-bar", {
        ref: "deliveryEstimateSideBar",
        attrs: { order: _vm.data },
        on: {
          "delivery-order-created": function ($event) {
            return _vm.$emit("delivery-order-created")
          },
        },
      }),
      _c("delivery-order-side-bar", {
        ref: "deliveryOrderSideBar",
        attrs: { order: _vm.data },
        on: { "restart-delivery": _vm.onAskDeliveryService },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }